<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col>
        HTTP Method Control
        <c-switch color="info" class="float-right" label variant="pill" size="sm" defaultChecked v-model="use_method" @change="change_use_method"/>
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3">
      <b-col>
        Method Name
      </b-col>
      <b-col sm="5" class="text-left">
        IP Address(In one row, enter one)
        <br>
        <small class="text-danger">If IP is not specified, it applies to the entire specified virtual domain.</small>
        <small class="text-danger">If you specify the IP, only the IP will be applied.</small>

      </b-col>
      <b-col sm="2" class="text-left">
        Block Mode
      </b-col>
      <b-col sm="3">
        Depend on Firewall Mode
      </b-col>
    </b-row>
    <hr>
    <b-row class="mb-3" v-for="(m, index) in method_list" :key="'_method_'+index" :style="use_method ? '' : 'text-decoration: line-through;'">
      <b-col>
        {{ m.method.toUpperCase() }} is
        <span v-if="m.is_mode">
          <b-badge v-if="now_mode == 0" variant="secondary">Off</b-badge>
          <b-badge v-if="now_mode == 1" variant="warning">DetectionOnly</b-badge>
          <b-badge v-if="now_mode == 2" variant="danger">Block</b-badge>
        </span>
        <span v-else>
          <b-badge v-if="m.is_block" variant="danger">Block</b-badge>
          <b-badge v-else variant="warning">DetectionOnly</b-badge>
        </span>
      </b-col>
      <b-col sm="5" class="text-left" v-if="m">
        <b-form-textarea :disabled="!use_method" @update="update($event, m.method, 'ip_list')" id="ph_content" v-model="m.ip_list" :max-rows="50"></b-form-textarea>
      </b-col>
      <b-col sm="2" class="text-left" v-if="m">
        <c-switch :disabled="m.is_mode || !use_method" color="danger" label variant="pill" size="sm" defaultChecked v-model="m.is_block" @change="update($event, m.method, 'is_block')"/>
      </b-col>
      <b-col sm="3" v-if="m">
        <c-switch :disabled="!use_method" color="primary" label variant="pill" size="sm" defaultChecked v-model="m.is_mode" @change="update($event, m.method, 'is_mode')"/>
      </b-col>
    </b-row>
    <hr>

    <!-- 설명 모달 영역 -->
    <b-modal title="Block Base Country Code"  class="modal-info" v-model="explain_modal" ok-variant="success" header-bg-variant="success" ok-only>
      <!-- <p>For country code blocking, you must use the GEO-IP function to convert IP to country</p>
      <p>123.123.123.123 	&rArr; KR  </p> -->
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
